import React, { useState, useEffect, Fragment } from 'react';
import logo from '../assets/images/vtsl_logo_black.png';
import tickMark from '../assets/images/Tick_Mark_Circle.png';
import man from '../assets/images/dashboard/user.png';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { withRouter } from "react-router";

import '../assets/scss/app-styles/signin.scss'

import axios from "axios";
import { RESETPASSWORD,NewPassword,RetypePassword,Reset} from "../constant";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye, faEyeSlash, faCheckCircle, faTimesCircle } from '@fortawesome/free-solid-svg-icons'



const ResetAppPassword = ({ history }) => {

    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [passwordStrength, setPasswordStrength] = useState(0);

    const [error, setError] = useState("");
    const [resetSuccess, setResetSuccess] = useState(false);

    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    // Password requirement states
    const [requirements, setRequirements] = useState({
        minLength: false,
        hasUpperCase: false,
        hasLowerCase: false,
        hasNumber: false,
        hasValidSymbol: false,
        noInvalidSymbols: true
    });

    const resetPassword = (evt) => {
        evt.preventDefault();
        const url = new URL(window.location.href);
        const ref = url.searchParams.get("ref");
        
        if(!newPassword || !confirmPassword){
            setError("Please fill both fields")
            return;
        }
        if(newPassword !== confirmPassword){
            setError("Passwords do not match")
            return;
        }
        
        // Check all requirements
        const allRequirementsMet = Object.values(requirements).every(req => req === true);
        if(!allRequirementsMet){
            setError("Please ensure all password requirements are met");
            return;
        }
        
        const payLoad = {
            ref: encodeURIComponent(ref),
            password: newPassword
        }
        axios.post(`${process.env.REACT_APP_API_URL}resetAppPassword`, payLoad)
        .then(response=>{
            setResetSuccess(true);
            //toast.info("Your password has been reset. Please go back to your V-CX Application to log back in!");
        })
        .catch(err=>{
            toast.error(err.response.data)
        });
    }

    const passwordKeyUpHandler = (evt) => {
        var strengthbar = document.getElementById("meter");
        const pass = evt.target.value;
        setError('');
        var strength = 0;
        
        // Check individual requirements
        const newRequirements = {
            minLength: pass.length >= 8,
            hasUpperCase: /[A-Z]/.test(pass),
            hasLowerCase: /[a-z]/.test(pass),
            hasNumber: /[0-9]/.test(pass),
            hasValidSymbol: /[$@#&!]/.test(pass),
            noInvalidSymbols: !/[£%^*()\-_\[\]{};'\\:"|,./<>?`~§±=+]/.test(pass)
        };
        
        setRequirements(newRequirements);
        
        // Calculate strength based on valid requirements only
        if (newRequirements.minLength) strength += 1;
        if (newRequirements.hasUpperCase) strength += 1;
        if (newRequirements.hasLowerCase) strength += 1;
        if (newRequirements.hasNumber) strength += 1;
        if (newRequirements.hasValidSymbol) strength += 1;
        
        // Penalize for invalid symbols
        if (!newRequirements.noInvalidSymbols) {
            strength = Math.max(0, strength - 1);
        }

        if (pass.length > 100) {
            setError('Maximum number of characters are 100');
            strength = Math.max(0, strength - 1);
        } 

        switch (strength) {
            case 0:
            strengthbar.style.width = '0%';
            strengthbar.style.backgroundColor = "red";
            break;

            case 1:
            strengthbar.style.width = '20%';
            strengthbar.style.backgroundColor = "red";
            break;

            case 2:
            strengthbar.style.width = '40%';
            strengthbar.style.backgroundColor = "orange";
            break;

            case 3:
            strengthbar.style.width = '60%';
            strengthbar.style.backgroundColor = "orange";
            break;

            case 4:
            strengthbar.style.width = '80%';
            strengthbar.style.backgroundColor = "yellow";
            break;

            case 5:
            strengthbar.style.width = '100%';
            strengthbar.style.backgroundColor = "#22af47";
            break;
        }

        setPasswordStrength(strength);
    }

    const RequirementItem = ({ met, text }) => (
        <div className="requirement-item" style={{ 
            display: 'flex', 
            alignItems: 'center', 
            marginBottom: '5px',
            fontSize: '12px'
        }}>
            <FontAwesomeIcon 
                icon={met ? faCheckCircle : faTimesCircle} 
                style={{ 
                    marginRight: '8px', 
                    color: met ? '#22af47' : '#dc3545',
                    fontSize: '14px'
                }} 
            />
            <span style={{ color: met ? '#22af47' : '#dc3545' }}>{text}</span>
        </div>
    );

    return (
        <Fragment>
            <div className="page-wrapper">
                <div className="auth-bg">
                    <div className="authentication-box">
                        <div className="text-center">
                            <img width="200" src={logo} alt="" />
                        </div>
                        <div className="card mt-4 p-4">
                            {
                                resetSuccess?
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="text-center">
                                                <img width="200" src={tickMark} alt="" />
                                            </div>
                                        </div>
                                        <div className="col-md-12" style={{textAlign:"center"}}>
                                            <h4>Your Password Has Been Reset</h4>
                                            <br/><br/>
                                            <h5>Please go back to your V-CX Application to log back in!</h5>
                                        </div>
                                    </div>
                                :
                                    <form className="theme-form">
                                        <h5 className="f-16 mb-3 f-w-600">{RESETPASSWORD}</h5>
                                        
                                        {/* Password Requirements Display */}
                                        <div className="form-group" style={{ marginBottom: '15px' }}>
                                            <label className="col-form-label" style={{ fontWeight: 'bold', marginBottom: '10px' }}>
                                                Password Requirements:
                                            </label>
                                            <div style={{ 
                                                backgroundColor: '#f8f9fa', 
                                                padding: '10px', 
                                                borderRadius: '5px',
                                                border: '1px solid #dee2e6'
                                            }}>
                                                <RequirementItem met={requirements.minLength} text="At least 8 characters" />
                                                <RequirementItem met={requirements.hasUpperCase} text="At least 1 uppercase letter (A-Z)" />
                                                <RequirementItem met={requirements.hasLowerCase} text="At least 1 lowercase letter (a-z)" />
                                                <RequirementItem met={requirements.hasNumber} text="At least 1 number (0-9)" />
                                                <RequirementItem met={requirements.hasValidSymbol} text="At least 1 symbol ($ @ # & !)" />
                                                <RequirementItem met={requirements.noInvalidSymbols} text="No invalid symbols (see note below)" />
                                            </div>
                                            <small style={{ color: '#6c757d', fontSize: '11px', marginTop: '5px', display: 'block' }}>
                                                <strong>Note:</strong> The following symbols are NOT allowed: £ % ^ * ( ) - _ [ ] {'{ }'} ; ' \ : " | , . / &lt; &gt; ? ` ~ § ± = +
                                            </small>
                                        </div>
                                        
                                        <div className="form-group">
                                            <label className="col-form-label">{NewPassword}</label>
                                            <input className="form-control password-eye"  type={showPassword? "text":"password"}  value={newPassword}
                                                    onChange={e => setNewPassword(e.target.value)} 
                                                    style={{fontSize:"12px"}}
                                                    onKeyUp={passwordKeyUpHandler}/>
                                            <div className="eye-password" onClick={e => setShowPassword(!showPassword)}>
                                                <FontAwesomeIcon icon={showPassword?faEyeSlash:faEye} />
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <label className="col-form-label">{RetypePassword}</label>
                                            <input className="form-control password-eye" type={showConfirmPassword? "text":"password"} value={confirmPassword}
                                                    onChange={e => setConfirmPassword(e.target.value)}
                                                    style={{fontSize:"12px"}} />
                                            <div className="eye-password" 
                                                onClick={e => setShowConfirmPassword(!showConfirmPassword)}>
                                                <FontAwesomeIcon icon={showConfirmPassword?faEyeSlash:faEye} />
                                            </div>
                                        </div>
                                        <div className="text-center">
                                            {/* <progress max="100" value="0" id="meter"></progress> */}
                                            <div className="progress"><div id="meter" className="progress-bar" role="progressbar" aria-valuenow="50" aria-valuemin="0" aria-valuemax="100" ></div></div>
                                            <h6 style={{color: "red"}} >{error} </h6>
                                        </div>
                                        <div className="form-group form-row mb-0">
                                            <div className="col-md-2">
                                                <button className="btn btn-primary" onClick={resetPassword}>{Reset}</button>
                                            </div>
                                        </div>
                                    </form>
                            }
                            
                        </div>
                    </div>
                    <ToastContainer />
                </div>
            </div>
        </Fragment>
    );
};

export default withRouter(ResetAppPassword);